
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { LabelText } from '../../Language';
import CustomOverlayTrigger from '../../../hoc/CustomOverlayTrigger';
import { changeRequestTooltip } from '../../../components/UI/Tooltip/Tooltip';
import './UnblockCrSuccess.css';



const UnblockCrSuccess = (props) => {
    const [show, setShow] = useState(true);
    const handleClose= () => {
        setShow(false);
        props.setShowUnblockModel();
    };

    return (
        <div className="UnblockSuccess-Modal-container">
            <Modal dialogClassName={"Model-dialogue"} show={show} 
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                scrollable={true}>
                {
                    <Modal.Header closeButton={true}
                        className="UnblockSuccess-Modal-header scroller"
                        style={{ backgroundColor: '#25336C' }} >
                    </Modal.Header>
                }
                <Modal.Body className="scroller">
                    <div className="Bulk-processing-body">
                        {props.statusData.map((data) => 
                        <div key={data.changeRequestNumber}>
                            <div className="UnblockSuccess-BusinessPartner-label-period">
                                <LabelText tid="unblockCrSuccessLine1" value={data.changeRequestNumber} /><br />
                                <LabelText tid="unblockCrSuccessLine2" value={data.contractCode} startDate={data.unblockStartDate} endDate={data.unblockEndDate} /><br />
                                <LabelText tid="unblockCrSuccessLine3" value={data.unblockValidTillDate} />
                            </div>
                            <hr></hr>
                        </div>)}
                        

                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="UnblockSuccess-Button-Container">
                        <div>
                            <div className="UnblockSuccess-Request-Btn-Container">
                                <CustomOverlayTrigger placement="left" tooltip={changeRequestTooltip("continue")}>
                                    <div className={"unblock-success-continue"} role={"button"} tabIndex={0}
                                        onClick={handleClose}
                                    ><LabelText tid="continue" /></div>
                                </CustomOverlayTrigger>
                            </div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
};

export default UnblockCrSuccess;